import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import cloudStore, { cloudStoreEvents } from "../../store/CloudStore";
import { Grid, Paper, TextField, Typography } from "@material-ui/core";
import { Create } from "@material-ui/icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import InlineEditor from "@ckeditor/ckeditor5-build-inline";
import CustomFields from "../CustomFields/CustomFields";
import { useParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { updateSpMerchant } from "../../store/SpMerchantApi";

function GuestRegistrationSetting(props) {
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const [guestRegistration, setGuestRegistration] = React.useState(
    cloudStore.merchant.sp_merchants.find((spMerchantCloud) => spMerchantCloud.id === spMerchantId)
      .guest_registration ?? {}
  );
  const [days, setDays] = React.useState(
    cloudStore.merchant.sp_merchants.find((spMerchantCloud) => spMerchantCloud.id === spMerchantId)
      .delete_sp_contact_details_after_days
  );

  const onChangeSpMerchant = () => {
    let newSpMerchant = {
      ...cloudStore.merchant.sp_merchants.find((spMerchantCloud) => spMerchantCloud.id === spMerchantId),
    };
    setGuestRegistration(newSpMerchant.guest_registration ?? {});
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
  }, []);

  return (
    <Paper style={{ width: "450px", padding: "16px", margin: "16px" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Create fontSize={"large"} />
        <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
          {props.intl.formatMessage({ id: "Guest registration" })}
        </Typography>
      </div>
      <Grid container alignItems={"center"} spacing={1}>
        <Grid item xs={4}>
          <Typography>{props.intl.formatMessage({ id: "Title" })}</Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            variant={"standard"}
            fullWidth
            value={guestRegistration.title ?? ""}
            onChange={(e) => {
              let newGuestRegistration = { ...guestRegistration };
              newGuestRegistration.title = e.target.value;
              setGuestRegistration(newGuestRegistration);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ height: 340 }}>
            <Typography>{props.intl.formatMessage({ id: "Content" })}</Typography>
            <div style={{ border: "1px solid grey", borderRadius: 3 }}>
              <CKEditor
                editor={InlineEditor}
                data={guestRegistration.content}
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  console.log({ event, editor, data });
                }}
                onBlur={(event, editor) => {
                  let newGuestRegistration = { ...guestRegistration };
                  newGuestRegistration.content = editor.getData();
                  setGuestRegistration(newGuestRegistration);

                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </div>
          </div>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label={"Delete after number of days"}
            variant={"outlined"}
            color={"primary"}
            type={"number"}
            value={days}
            onChange={(e) => {
              setDays(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomFields
            customFields={guestRegistration.custom_fields ?? []}
            onChange={(customFields) => {
              setGuestRegistration({ ...guestRegistration, custom_fields: customFields });
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => {
              updateSpMerchant(
                cloudStore.merchant.sp_merchants.find((spMerchantCloud) => spMerchantCloud.id === spMerchantId),
                { guest_registration: guestRegistration, delete_sp_contact_details_after_days: parseInt(days) }
              );
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default withIntl(GuestRegistrationSetting);
